// extracted by mini-css-extract-plugin
export default {"R2R3Wrapper":"r2-r3_R2R3Wrapper__evCkL","contentBlock":"r2-r3_contentBlock__3uQY0"};